import React, { FC } from 'react';
import { BatchWithColor, HoverState, ERPState, IFontStyles } from '@v2/context/ProductionBatch/types';
import { ProductionBatch } from '@interfaces/search';
import { shouldHideInfoOnHover, shouldHideLinkedInfoIfNoERP, shouldHideLinkedInfo, getLinkedInfoText } from '@v2/context/ProductionBatch/tile/helpers';
import { Text } from 'react-native';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';

export interface LinkedInfoProps
  extends Pick<ProductionBatch, 'links' | 'ncFileStatus'>,
    Pick<BatchWithColor, 'C'>,
    HoverState,
    ERPState,
    IFontStyles {}

const LinkedInfo: FC<LinkedInfoProps> = ({ links, ncFileStatus, C, hovered, isWithERP, fontType = 'Footnote', color = 'Label/Light/Tertiary' }) => {
  const shouldHide =
    (hovered && shouldHideInfoOnHover({ isWithERP, links, ncFileStatus })) ||
    shouldHideLinkedInfoIfNoERP(links, ncFileStatus, isWithERP) ||
    shouldHideLinkedInfo(links, ncFileStatus);

  if (shouldHide) {
    return null;
  }

  const commonText = getLinkedInfoText(links, ncFileStatus);
  const linkId = links?.[0]?.productionOrderNumber;

  const linksExist = links?.length > 0;
  const singleLink = links?.length === 1;

  return (
    <Text numberOfLines={1} style={[font[fontType], { color: C(color), flexGrow: 0, flexShrink: 1, minWidth: 0 }]}>
      {i18n.t(commonText)}{' '}
      {linksExist && <Text style={{ textDecorationLine: 'underline' }}> {singleLink ? linkId : `${links.length} ${i18n.t('Jobs')}`}</Text>}
    </Text>
  );
};

export default LinkedInfo;
